































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import FilterParams, { InvoiceFilterParams } from '@/types/FilterParams.interface'
import IList from '@/types/components/IList.interface'
import Invoice from '@/types/Invoice.interface'
import InvoicesPlaceholder from '@/components/InvoicesPlaceholder.vue'
import Message from '@/types/Message.interface'
import { InvoiceParams } from '@/types/PaginationParams.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import invoicesMixin from '@/mixins/invoices-mixin'
import SmsOutboundBubble from '@/components/SmsOutboundBubble.vue'
export default Vue.extend({
    mixins: [invoicesMixin],
    components: { InvoicesPlaceholder, SmsOutboundBubble },
    data() {
        return {
            //  Our placeholder for when we have 0 invoices
            invoicesListPlaceholder: {
                content: 'No Invoices to Display',
                img: 'noInvoices'
            },
            //  Determines if we had searched or not
            mounted: false,
            toolbar: {
                title: 'Invoices',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/home',
                        tooltip: 'Back',
                        permission: 0
                    }
                ]
            }
        }
    },
    beforeDestroy() {
        //  Before leaving, set our selected invoice to null
        this.selectedInvoice = null
    },
    mounted() {
        //  Find the filter that matches the current param
        const selected = this.filter.options.find(
            (x: FilterParams) => x.value === this.invoicesParams.filter
        )

        //  Set this as the new selected
        this.filter.selected = selected

        //  Set mounted to true since we are finished
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            invoicesParamsDefault: 'paymentsInvoicesParamsDefault',
            lastPage: 'paymentsInvoicesLastPage',
            scrollPositionLeft: 'scrollPositionLeft'
        }),
        invoices(): Invoice[] {
            //  If we have searched, return the search results
            if (this.searched) return this.searchResults
            //  Else, just display our templates
            else return this.$store.getters.paymentsInvoices
        },
        invoicesIList(): IList {
            return this.$store.getters.iList('paymentsInvoicesList')
        },
        invoicesParams: {
            get(): InvoiceParams {
                return this.$store.getters.paymentsInvoicesParams
            },
            set(val: InvoiceParams): void {
                this.$store.commit('paymentsInvoicesParamsSet', val)
            }
        },
        multiSelectInvoiceIds(): number[] {
            //  If the invoicesIList does NOT exist, return empty array
            if (!this.invoicesIList) return []

            //  Assemble an array of multi-selected invoice ids
            const ids = this.invoicesIList.multiSelected.map(
                (invoice: Invoice) => invoice.id
            )

            //  Return the invoice ids
            return ids
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        paginating(): boolean {
            //  Get our invoice list paginating
            const invoicePaginating = this.$store.getters.paymentsInvoicesPaginating

            //  Get our selected invoice paginating
            const selectedPaginating =
                this.$store.getters.paymentsSelectedInvoicePaginating

            //  We are paginating if either of these are true
            return invoicePaginating || selectedPaginating
        },
        selectedInvoice: {
            get(): Invoice {
                return this.$store.getters.paymentsSelectedInvoice
            },
            set(val: Invoice): void {
                this.$store.commit('paymentsSelectedInvoiceSet', val)
            }
        },
        selectedInvoiceMessages: {
            get(): Message[] {
                return this.$store.getters.paymentsSelectedInvoiceMessages
            },
            set(val: Message[]): void {
                this.$store.commit('paymentsSelectedInvoiceMessagesSet', val)
            }
        },
        selectedInvoiceSelectedMessage: {
            get(): Message {
                return this.$store.getters.paymentsSelectedInvoiceSelectedMessage
            },
            set(val: Message): void {
                this.$store.commit('paymentsSelectedInvoiceSelectedMessageSet')
            }
        }
    },
    methods: {
        //  Checks if this invoice is paid or not (stupid linter doesn't allow this inline)
        invoicePaid(invoice: Invoice): boolean {
            return invoice.balance <= 0
        },
        //  Occurs whenever a filter is modified
        onFilterChanged(filter: InvoiceFilterParams): void {
            //  Grab the key and value from our filter
            const key = filter.key
            const value = filter.value

            //  Get our current params
            const params = this.invoicesParams

            //  Check if we currently have this filter applied
            const isSame = params[key] === value

            //  If it is the same, do nothing
            if (isSame) return

            //  Else, apply this to our params
            params[key] = value

            //  Set page to 1 since we changed our filter
            params.page = 1

            //  (our computed setter will apply this in the store)
            this.invoicesParams = params

            //  Deselect multiselected items
            this.$refs.invoicesList.multiSelectReset()

            //  The filter was changed so we should paginate the new filter
            this.$store.dispatch('paymentsInvoicesPaginate')
        },
        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.invoicesParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage

            //  (our computed setter will apply this in the store)
            this.invoicesParams = params

            //  Deselect multiselected items
            this.$refs.invoicesList.multiSelectReset()

            //  Paginate the next page
            this.$store.dispatch('paymentsInvoicesPaginate')
        },
        //  Displays our invoice in the right panel and retrieves its messages
        onInvoiceSelected(invoice: Invoice): void {
            //  Push tri-panel to step two (for mobile layout)
            this.$refs.paymentsInvoicesPage.step = 2

            //  Check if the invoice is different form the currently selected invoice
            const isNew = !this.selectedInvoice || this.selectedInvoice.id != invoice.id

            //  If the invoice is NOT different from the current selected invoice, do nothing
            if (!isNew) return

            //  Else, set our selected invoice (the watcher will get the messages)
            this.$store.dispatch('paymentsSelectedInvoiceGet', invoice.id)
        },
        //  When unsetting the invoice we unset selected invoice, messaage, and messages
        unsetInvoice(): void {
            //  Unset our invoices
            this.selectedInvoice = null

            //  Unset our messages
            this.selectedInvoiceMessages = []

            //  Unset our message
            this.selectedInvoiceSelectedMessage = null
        }
    },
    watch: {
        selectedInvoice(invoice: Invoice): void {
            //  If the invoice was set to null, set the messages to null too
            if (!invoice) return this.unsetInvoice()

            //  Else, get our messages for this group
            this.$store.dispatch('paymentsSelectedInvoiceMessagesGet', invoice.id)
        },
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        }
    }
})
